import job_preview_content from '../job_preview_content/JobPreviewContent.vue';
import job_editor_content from '../job_editor_content/JobEditorContent.vue';

export default {
  name: 'job_preview_modal',
  components: { job_preview_content, job_editor_content },
  data: () => ({
    is_open: false,
    _modal_show_handler: null,
    _modal_hide_handler: null,
  }),
  props: {
    parsed_document: { type: Object, default: null },
    parsed_job_id: { type: [Number, String], default: null },
    parsed_raw_text: { type: String, default: null },
    parsed_active_section: { type: String, default: 'meta' },
    parsed_editor_mode: { type: String, default: 'split' },
    parsed_history: { type: Array, default: () => [] },
    parsed_history_index: { type: Number, default: -1 },
    parsed_sections: { type: Array, default: () => [] },
    parsed_completion_percent: { type: Number, default: 0 },
    parsed_is_ready: { type: Boolean, default: false },
    parsed_save_state: { type: String, default: 'idle' },
    parsed_save_message: { type: String, default: '' },
    parsed_responsibility_index: { type: Number, default: 0 },
  },
  computed: {
    should_show_parsed_preview() {
      return this.parsed_editor_mode === 'preview' || this.parsed_editor_mode === 'split';
    },
    should_show_parsed_editor() {
      return this.parsed_editor_mode === 'edit' || this.parsed_editor_mode === 'split';
    },
    progress_width_class() {
      const percent = Number(this.parsed_completion_percent) || 0;
      if (percent <= 0) return 'd-none';
      if (percent < 26) return 'w-25';
      if (percent < 51) return 'w-50';
      if (percent < 76) return 'w-75';
      return 'w-100';
    },
  },
  mounted() {
    const modal_el = document.getElementById('view_job_profile_modal');
    if (!modal_el) return;

    this._modal_show_handler = () => {
      this.is_open = true;
    };

    this._modal_hide_handler = () => {
      this.is_open = false;
    };

    modal_el.addEventListener('show.bs.modal', this._modal_show_handler);
    modal_el.addEventListener('hidden.bs.modal', this._modal_hide_handler);
  },
  beforeUnmount() {
    const modal_el = document.getElementById('view_job_profile_modal');
    if (!modal_el) return;

    if (this._modal_show_handler) {
      modal_el.removeEventListener('show.bs.modal', this._modal_show_handler);
    }
    if (this._modal_hide_handler) {
      modal_el.removeEventListener('hidden.bs.modal', this._modal_hide_handler);
    }
  },
  methods: {
    collapse_modal() {
      const modal_el = document.getElementById('view_job_profile_modal');
      if (!modal_el || !window.bootstrap?.Modal) return;

      const modal_instance = window.bootstrap.Modal.getInstance(modal_el) || new window.bootstrap.Modal(modal_el);
      modal_instance.hide();
    },
    section_has_content(section_key) {
      if (!this.parsed_document) return false;
      const doc = this.parsed_document;
      if (section_key === 'meta') return Object.values(doc.meta || {}).some(v => v);
      if (section_key === 'job_purpose') return !!doc.job_purpose;
      if (section_key === 'main_functions') return Array.isArray(doc.main_functions) && doc.main_functions.length > 0;
      if (section_key === 'responsibilities') return Array.isArray(doc.responsibilities) && doc.responsibilities.length > 0;
      if (section_key === 'outputs_profile') return Array.isArray(doc.outputs_profile) && doc.outputs_profile.length > 0;
      if (section_key === 'competencies') {
        const comp = doc.competencies || {};
        return Object.values(comp).some(v => Array.isArray(v) ? v.length > 0 : !!v);
      }
      if (section_key === 'career_pathing') return !!doc.career_pathing;
      if (section_key === 'amendments') return !!doc.amendments;
      if (section_key === 'performance_agreement') return !!doc.performance_agreement;
      if (section_key === 'signatories') return Array.isArray(doc.signatories) && doc.signatories.length > 0;
      return false;
    },
  },
};
